import config from './config.yaml';
import {throttle} from 'throttle-debounce';
import CAccordions from '../../index.js';

/**
 * Реализует логику варианта base компонента accordions
 */
class CAccordions_base extends CAccordions {
	constructor() {
		super();
		this.config = config;
	}

	/**
	 * Инициализация
	 */
	init() {
		const $accordions = $('.js-accordion');

		if ($accordions.length) {
			this.initAccordions($accordions);
		}
	}

	/**
	 * Инициализация скриптов для аккордеонов
	 * @param {object} $accordions аккордеоны
	 */
	initAccordions($accordions) {
		this.hashStack = [];

		$accordions.each((i, elem) => {
			const $elem = $(elem);
			const isNoHash = $elem.hasClass('js-accordion--no-hash');
			const $controls = $elem.children('.js-accordion-control').find('.js-accordion-control-item');
			const $section = $elem.children('.js-accordion-section');
			const $buttons = $section.children('.js-accordion-header').find('.js-accordion-button');

			if (this.config.showArticleCloseBtnCondition) {
				const $articles = $section.children('.js-accordion-article');
				this.createCloseArticleButtons($articles, isNoHash);
			}

			if ($controls.length) {
				$controls.on('click', $.proxy(this, 'expandCollapse'));
			}

			$buttons.on('click', $.proxy(this, 'toggle', isNoHash));
		});

		const $svg = $('[data-svg]');
		if ($svg.length) {
			AR.events.on('svgRenderedAll', () => {
				const openedByHash = this.checkHash();

				if (!openedByHash) {
					const $accordionsWithDataOpen = $accordions.filter((i, elem) => $(elem).data('open'));

					if ($accordionsWithDataOpen.length) {
						this.openByDataOpen($accordionsWithDataOpen);
					}
				}
			});
		} else {
			const openedByHash = this.checkHash();

			if (!openedByHash) {
				const $accordionsWithDataOpen = $accordions.filter((i, elem) => $(elem).data('open'));

				if ($accordionsWithDataOpen.length) {
					this.openByDataOpen($accordionsWithDataOpen);
				}
			}
		}
	}

	/**
	 * Открытие аккордеонов с атрибутом data-open
	 * @param {object} $accordions аккордеоны
	 */
	openByDataOpen($accordions) {
		$accordions.each((i, elem) => {
			const $elem = $(elem);
			const isNoHash = $elem.hasClass('js-accordion--no-hash');
			const itemNum = $elem.data('open');
			const $targetButton = $elem
				.children('.js-accordion-section')
				.children('.js-accordion-header')
				.find('.js-accordion-button')
				.eq(itemNum - 1);

			this.open($targetButton);

			if (!isNoHash) {
				this.setHashAndPush($targetButton.attr('href'));
			}
		});
	}

	/**
	 * Скрыть / раскрыть все секции аккордеона
	 * @param {object} event событие клика
	 */
	expandCollapse(event) {
		const $control = $(event.currentTarget);
		const action = $control.hasClass('js-accordion-control-item--expand') ? 'expand' : 'collapse';
		const $accordion = $control.closest('.js-accordion');
		const $targetButtons = action == 'expand' ? $accordion.find('.js-accordion-button:not(.is-expand)') : $accordion.find('.js-accordion-button.is-expand');

		if ($targetButtons.length) {
			$targetButtons.each((i, elem) => {
				const $elem = $(elem);
				const isNoHash = $elem.closest('.js-accordion').hasClass('js-accordion--no-hash');

				if (action == 'expand') {
					this.open($elem, this.config.animation.open.duration, true);
					if (!isNoHash) {
						this.setHashAndPush($elem.attr('href'));
					}
				} else {
					this.close($elem, isNoHash, true);
				}
			});
		}
	}

	/**
	 * Создание кнопок закрытия секции в конце контентной области секции
	 * @param {object} $articles контентная область секции
	 * @param {boolean} isNoHash аккордеон без хэшей
	 */
	createCloseArticleButtons($articles, isNoHash) {
		$articles.each((i, article) => {
			const $article = $(article);
			const $articleClose = $('<button class="b-accordion__article-close js-accordion-article-close"></button>');
			const $button = $article.siblings('.js-accordion-header').find('.js-accordion-button');
			$article.append($articleClose);

			$articleClose.on('click', $.proxy(this, 'close', $button, isNoHash));
		});

		if (this.config.showArticleCloseBtnCondition == 'longerThanWindow') {
			$(window).resize(throttle(150, () => {
				const $expandedArticles = $('.js-accordion-article.is-expand');

				if ($expandedArticles.length) {
					$expandedArticles.each((i, elem) => {
						this.showArticleClose($(elem));
					});
				}
			}));
		}
	}

	/**
	 * закрыть соседние секции
	 * @param {object} $button кнопка секции
	 */
	closeSiblings($button) {
		$button
			.closest('.js-accordion-section')
			.siblings('.js-accordion-section')
			.find('.js-accordion-button.is-expand')
			.each((i, elem) => {
				this.close($(elem));
			});
	}


	/**
	 * Показать кнопку закрытия секции
	 * @param {object} $article контентная область секции
	 */
	showArticleClose($article) {
		const windowHeight = $(window).height();
		const $header = $article.siblings('.js-accordion-header');
		const sectionHeight = $header.height() + $article.innerHeight();
		const $articleClose = $article.children('.js-accordion-article-close');

		if ($articleClose.hasClass('is-hidden') && sectionHeight > windowHeight) {
			$articleClose.removeClass('is-hidden');
		} else if (!$articleClose.hasClass('is-hidden') && sectionHeight < windowHeight) {
			$articleClose.addClass('is-hidden');
		}
	}

	/**
	 * Открыть / закрыть секцию аккордеона
	 * @param {boolean} isNoHash аккордеон без хэшей
	 * @param {object} event событие клика
	 */
	toggle(isNoHash, event) {
		event.preventDefault();
		const $button = $(event.currentTarget);

		if ($button.hasClass('is-expand')) {
			this.close($button, isNoHash);
		} else {
			this.open($button);

			if (!isNoHash) {
				this.setHashAndPush($button.attr('href'));
			}

			if (this.config.closeSiblings) {
				this.closeSiblings($button);
			}
		}
	}

	/**
	 * Открыть секцию аккордеона
	 * @param {object} $button кнопка секции
	 * @param {number} duration длительность анимации открытия
	 * @param {boolean} noScrollTo не скролить
	 */
	open($button, duration, noScrollTo = false) {
		const $section = $button.closest('.js-accordion-section');
		const $article = $section.children('.js-accordion-article');
		let extraScroll = 0;

		if (this.config.closeSiblings) {
			const $prevOpened = $section
				.prevAll('.js-accordion-section')
				.children('.js-accordion-header')
				.find('.js-accordion-button.is-expand');

			if ($prevOpened.length) {
				$prevOpened
					.closest('.js-accordion-header')
					.siblings('.js-accordion-article')
					.each((i, elem) => {
						extraScroll -= $(elem).innerHeight();
					});
			}
		}

		if (this.config.showArticleCloseBtnCondition == 'longerThanWindow') {
			this.showArticleClose($article);
		}

		$button
			.addClass('is-expand');
		$article
			.addClass('is-expand')
			.velocity(this.config.animation.open.effect, {
				duration: duration || this.config.animation.open.duration,
				begin: () => AR.events.emit('onAccordionsBaseOpenStart', $button),
				complete: () => AR.events.emit('onAccordionsBaseOpenEnd', $button)
			});
		$section
			.addClass('is-expand');

		if (this.config.scrollOnOpen && !noScrollTo) {
			this.scrollTo($button, extraScroll);
		}
	}

	/**
	 * Закрыть секцию аккордеона
	 * @param {object} $button кнопка секции
	 * @param {boolean} isNoHash аккордеон без хэшей
	 * @param {boolean} noScrollTo не скролить
	 */
	close($button, isNoHash = false, noScrollTo = false) {
		const $section = $button.closest('.js-accordion-section');
		const $article = $section.children('.js-accordion-article');

		$button
			.removeClass('is-expand');
		$article
			.removeClass('is-expand')
			.velocity(this.config.animation.close.effect, {
				duration: this.config.animation.close.duration,
				begin: () => AR.events.emit('onAccordionsBaseCloseStart', $button),
				complete: () => AR.events.emit('onAccordionsBaseCloseEnd', $button)
			});
		$section
			.removeClass('is-expand');


		if (!isNoHash) {
			const href = $button.attr('href');
			this.removeFromHashStack(href);
			this.removeHash(href);
		}

		if (this.config.closeInsideAccordionsOnClose) {
			$article
				.find('.js-accordion-button.is-expand')
				.each((i, elem) => this.close($(elem)));
		}

		if (this.config.scrollOnClose && !noScrollTo) {
			this.scrollTo($button);
		}
	}

	/**
	 * Открыть секцию и секции родительских аккордеонов
	 * @param {object} $parents родительские аккордеоны
	 */
	openSelfAndParents($parents) {
		const parentsLength = $parents.length;

		$parents.each((i, elem) => {
			const $elem = $(elem);
			const isNoHash = $elem.closest('.js-accordion').hasClass('js-accordion--no-hash');
			const $button = $elem.children('.js-accordion-header').find('.js-accordion-button');

			if (parentsLength - 1 == i || parentsLength == 1) {
				this.open($button);
			} else {
				this.open($button, '0');
			}

			if (!isNoHash) {
				this.pushToHashStack($button.attr('href'));
			}
		});

		this.hashStack.reverse();
	}

	/**
	 * Проверка хэша страницы на существование аккордеона с таким хэшом
	 */
	checkHash() {
		const hash = window.location.hash;
		const $targetElem = $(`[href="${hash}"]`);
		const isNoHash = $targetElem.closest('.js-accordion').hasClass('js-accordion--no-hash');
		const $parents = $targetElem.parents('.b-accordion__section');

		if ($targetElem.length && !($parents.length == 1 && isNoHash)) {
			this.openSelfAndParents($parents);

			return true;
		} else {
			return false;
		}
	}

	/**
	 * Изменить хэш страницы и добавить хэш с хранилище хэшей
	 * @param {string} href ссылка кнопки (хэш)
	 */
	setHashAndPush(href) {
		this.setHash(href);
		this.pushToHashStack(href);
	}

	/**
	 * Изменить хэш страницы
	 * @param {string} hash хэш
	 */
	setHash(hash) {
		window.location.hash = hash;
	}

	/**
	 * Удалить хэш или изменить хэш на предыдущий
	 */
	removeHash() {
		const previousHash = this.hashStack[this.hashStack.length - 1];
		window.location.hash = previousHash || '!';
	}

	/**
	 * Добавить хэш в хранилище хэшей
	 * @param {string} hash хэш
	 */
	pushToHashStack(hash) {
		this.hashStack.push(hash);

		if (!config.closeInsideAccordionsOnClose) {
			const $button = $(`.js-accordion-button[href="${hash}"]`);
			const $article = $button.closest('.js-accordion-section').children('.js-accordion-article');
			const $expandedArticles = $article.find('.js-accordion-button.is-expand');

			if ($expandedArticles.length) {
				$expandedArticles.each((i, elem) => {
					const href = $(elem).attr('href');
					this.hashStack.push(href);
				});
			}
		}
	}

	/**
	 * Удалить хэш из хранилища хэшей
	 * @param {string} href ссылка кнопки (хэш)
	 */
	removeFromHashStack(href) {
		const hashIndex = this.hashStack.indexOf(href);

		if (hashIndex > -1) {
			this.hashStack.splice(hashIndex, 1);
		}
	}

	/**
	 * Скролить к кнопке секции аккордеона
	 * @param {object} $button кнопка секции
	 * @param {Number} extraScroll дополнительное расстояние, на которое нужно отскролить
	 */
	scrollTo($button, extraScroll = 0) {
		const topPos = $button.offset().top;

		$('html').velocity('scroll', {
			offset: topPos + extraScroll + 'px',
			duration: this.config.animation.scrollTo.duration,
			mobileHA: false
		});
	}
}

AR.waitComponents([], () => {
	const cAccordions_base = new CAccordions_base();
	// Вызов метода, инициализирующего все существующие события
	cAccordions_base.init();
	// Добавление в глобальный объект AR.components
	AR.pushComponent(cAccordions_base, 'cAccordions_base');
});
